import React from 'react';
import { GameState } from '../types';
import { Language } from '../data/translations';
import Card from './Card';
import * as gameLogic from '../services/gameLogic';

const LockedCardOverflowModal: React.FC<{
    gameState: GameState;
    onChoose: (cardId: string) => void;
    language: Language;
}> = ({ gameState, onChoose, language }) => {
    const lockedCards = gameLogic.getLockedCardsInOverflow(gameState);
    const excessCount = lockedCards.length - (gameState.overflowMaxSlots || 0);

    if (excessCount <= 0) return null;

    return (
        <div className="absolute inset-0 bg-black/80 backdrop-blur-sm flex flex-col items-center justify-center z-40">
            <h2 className="text-4xl font-bold mb-2 text-red-400 text-shadow-lg">Slot Overflow!</h2>
            <p className="text-xl text-slate-300 mb-8">You have too many locked cards. Choose <span className="font-bold text-white">{excessCount}</span> to return to your hand.</p>
            <div className="flex items-center justify-center gap-4">
                {lockedCards.map(pCard => (
                    <div key={pCard.card.id} className="cursor-pointer transform hover:scale-110 transition-transform duration-300">
                        <Card
                            card={pCard.card}
                            rotation={pCard.rotation}
                            locked={true}
                            isClickable={true}
                            onClick={() => onChoose(pCard.card.id)}
                            language={language}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LockedCardOverflowModal;
